exports.install = function (Vue, options) {
	//获取设备数据列表
	Vue.prototype.getdevicesdata1 = function(value,type=0)
	{
		return this.axiosget("/api/"+(type==0?"devicesdata":"Smogdata")+"/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				if(type==0)
				{
					this.$store.commit('devicesdata1',response.data.data.terminalInfo);
				}
				else
				{
					this.$store.commit('devicesdata1',response.data.data);
				}
			}
			return response;
		})
	};
	//获取设备数据列表
	Vue.prototype.getdevicesdata2 = function(value)
	{
		return this.axiosget("/api/devicesdata/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('devicesdata2',response.data.data.terminalInfo);
			}
			return response;
		})
	};
}